import { render, staticRenderFns } from "./VolumeLineChartSimple.vue?vue&type=template&id=52b36c70"
import script from "./VolumeLineChartSimple.vue?vue&type=script&lang=js"
export * from "./VolumeLineChartSimple.vue?vue&type=script&lang=js"
import style0 from "./VolumeLineChartSimple.vue?vue&type=style&index=0&id=52b36c70&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports